import * as React from "react";
import { ISelectDropDownProps } from "../../../interfaces/Index";
import { Label } from "reactstrap";
import "./SelectDropDown.scss";

export const SelectDropDown: React.FC<ISelectDropDownProps> = (props) => {
  const { options } = props;
  const optionItem = options.map((item: any, index: number) => {
    return (
      <option id={item.id} value={item.key} key={index}>
        {item.title}
      </option>
    );
  });

  return (
    <div className="form-group">
      <Label className="block text-uppercase label">{props.label}</Label>
      <select
        className="form-control"
        id={props.id}
        onChange={props.handleChange}
        name="select"
        value={props.value}
        disabled={props.disabled}
      >
        <option
          id={props.defaultOption.id}
          value={props.defaultOption.value}
          key={-1}
        >
          {props.defaultOption.text}
        </option>
        {optionItem}
      </select>
    </div>
  );
};

SelectDropDown.defaultProps = {
  disabled: false,
};
